module.exports = __webpack_public_path__ + "static/img/m3_t4b_text1.6eb5d03d.jpg";